export default {
  props:['value','multiple'],
  data(){
    return {
      currentValue:null,
      licenses:[]
    }
  },
  created(){
    this.$watch('value' , function(nv){
      this.currentValue = nv
    })
    this.licenses = () => this.$request.licenseAll().then( resp => {
      return Promise.resolve( resp.data.map(i => ({value:i.id , label:i.name})) )
    })
  },
  methods:{
    handleChange(val){
      this.currentValue = val
      this.$emit('change' , val)
      this.$emit('input' , val)
    }
  },
  render(){
    let multiple = this.multiple === undefined ? true : false
    return <sl-select placeholder="请选择适用证照" multiple={multiple} value={this.value} dict={this.licenses} on-change={this.handleChange} />
  }
}